import { BannerSection } from '@web_opxp/components';
import { useTranslation } from '@web_opxp/language';
import { CheckIcon } from '@web_opxp/icons';
import * as React from 'react';
import ENV from '../../base/env';
import './PremiumGetSection.scss';

export const PremiumGetSection: React.FC = () => {
  /* eslint-disable */
  const { t } = useTranslation();
  const title = t('PremiumGetSection.Title');
  const description = '';
  const imgSrc = `${ENV.AssetsBaseUrl}/feature/premium_benefits.png`;

  const benefitItems: React.ReactNode[] = [];
  for (let i = 1; i <= 6; i++) {
    benefitItems.push(
      <p className="item-container" key={i}>
        <CheckIcon /> {t(`PremiumGetSection.Benefit${i}`)}
      </p>
    );
  }

  return (
    <BannerSection direction="left" title={title} description={description} imgSrc={imgSrc} id="premium-get-section">
      {benefitItems}
    </BannerSection>
  );
};

export default PremiumGetSection;
